export {
  default as conferenceSpace,
  ReactComponent as ConferenceSpace,
} from '@assets/icons/use-cases/conference-space.svg'    
